export enum Compliance {
  Compliant = 1,
  NonCompliant = 0,
  NonEligible = 2,
}
